import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Shop from '@/pages/Shop';
import Varieties from '@/pages/Varieties';
import Wholesale from '@/pages/Wholesale';
import Growers from '@/pages/Growers';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import NotFound from '@/pages/NotFound';
import { OrganizationJsonLd } from '@/components/Seo';

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <OrganizationJsonLd />
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/varieties" element={<Varieties />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/growers" element={<Growers />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
